function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgNationalPark = function SvgNationalPark(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64",
    width: 512,
    height: 512,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "flat"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 6,
    height: 58,
    style: {
      fill: "#995023"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 3,
    width: 6,
    height: 58,
    style: {
      fill: "#995023"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 5,
    width: 46,
    height: 40,
    style: {
      fill: "#c9c9c9"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 9,
    width: 30,
    height: 32,
    style: {
      fill: "#96b567"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 8,
    width: 2,
    height: 2,
    style: {
      fill: "#919191"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 12,
    width: 6,
    height: 2,
    style: {
      fill: "#919191"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 16,
    width: 6,
    height: 2,
    style: {
      fill: "#919191"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 20,
    width: 2,
    height: 2,
    style: {
      fill: "#919191"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 24,
    width: 6,
    height: 2,
    style: {
      fill: "#919191"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 28,
    width: 6,
    height: 2,
    style: {
      fill: "#919191"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 32,
    width: 2,
    height: 2,
    style: {
      fill: "#919191"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 36,
    width: 6,
    height: 2,
    style: {
      fill: "#919191"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 40,
    width: 6,
    height: 2,
    style: {
      fill: "#919191"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.351,38H27V22.133l7-1V18.781l-4.452-1.113L32.382,12H42.469l5.656,6.788L47,22.162V34H39.351Z",
    style: {
      fill: "#7a974e"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 9,
    width: 2,
    height: 9,
    style: {
      fill: "#7a974e"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 26,
    width: 2,
    height: 2,
    style: {
      fill: "#fdb62f"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 23,
    width: 2,
    height: 2,
    style: {
      fill: "#fdb62f"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 16,
    width: 2,
    height: 2,
    style: {
      fill: "#fdb62f"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 27,
    width: 2,
    height: 2,
    style: {
      fill: "#fdb62f"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 31,
    width: 2,
    height: 2,
    style: {
      fill: "#fdb62f"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 12,
    width: 2,
    height: 2,
    style: {
      fill: "#fdb62f"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 36,
    width: 2,
    height: 2,
    style: {
      fill: "#fdb62f"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 34,
    width: 2,
    height: 7,
    style: {
      fill: "#7a974e"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "34.351 38 33.365 38 34.773 41 36.982 41 35.24 37.288 34.351 38",
    style: {
      fill: "#7a974e"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 29,
    width: 6,
    height: 2,
    style: {
      fill: "#7a974e"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "48.125 18.788 47.721 20 51 20 51 18 47.468 18 48.125 18.788",
    style: {
      fill: "#7a974e"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "42.469 12 43.353 13.061 46.707 9.707 46 9 44.586 9 41.586 12 42.469 12",
    style: {
      fill: "#7a974e"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "27 38 27 36.654 23.578 41 26.124 41 28.486 38 27 38",
    style: {
      fill: "#7a974e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.908,24.023,24,22.721V17.153l7.041-1.174L36,17.219v5.648Z",
    style: {
      fill: "#5ea9db"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 5,
    width: 2,
    height: 40,
    style: {
      fill: "#bdbdbd"
    }
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNationalPark, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/national-park.3ad6dfda.svg";
export { ForwardRef as ReactComponent };